import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const AddGuestsModal = ({ show, onHide, onSave }) => {
  const [guestName, setGuestName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [isMandatory, setIsMandatory] = useState(false);

  const handleSave = () => {
    onSave({ guestName, guestEmail, isMandatory });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Guest</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Guest Name</label>
          <input
            type="text"
            className="form-control"
            value={guestName}
            onChange={(e) => setGuestName(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Guest Email</label>
          <input
            type="email"
            className="form-control"
            value={guestEmail}
            onChange={(e) => setGuestEmail(e.target.value)}
          />
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="mandatory"
            checked={isMandatory}
            onChange={() => setIsMandatory(!isMandatory)}
          />
          <label className="form-check-label" htmlFor="mandatory">
            Mandatory
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="success" onClick={handleSave}>
          Save Guest
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddGuestsModal;
